import { get as apiGet, put as apiPut } from '../lib/api/client';
import type { RecipientActivity, ActivityCountResponse } from '../types/activity';

export async function getActivities(
  profileId: string,
  status: string,
  fetchSize: number,
  lastActivityId?: string,
): Promise<RecipientActivity[]> {
  let url = `/activity/recipient/${profileId}?status=${status}&fetchSize=${fetchSize}`;
  if (lastActivityId) url += `&lastActivityId=${lastActivityId}`;
  return apiGet<RecipientActivity[]>(url);
}

export async function getActivityCount(profileId: string, status: string): Promise<ActivityCountResponse> {
  return apiGet<ActivityCountResponse>(`/activity/recipient/${profileId}/count?status=${status}`);
}

export async function markActivitiesRead(profileId: string, activityIds: string[]): Promise<void> {
  await apiPut<void>(`/activity/recipient/${profileId}?status=read`, activityIds);
}
